import enLang from './entries/en-US';
import KhLang from './entries/km-KH';

const AppLocale = {
  en: enLang,
  kh: KhLang
};

export default AppLocale;
